import { useTranslation } from "@impero-com/common/utils/i18n";
import { SectionGroup } from "@impero-com/ui";

import { useGetOrganizationSettingsSuspense } from "api/generated/organization-settings/organization-settings";

import { OrgApplicationBar } from "../../components/applicationBar/orgApplicationBar";
import { useNewMenu } from "../navigation/useNewMenu";
import { SettingsLayout } from "../settings/SettingsLayout";

import { ControlPolicyCard } from "./ControlPolicyCard";
import { ControlPolicyRecentChanges } from "./ControlPolicyRecentChanges";

export function ControlPoliciesPage() {
    const { t } = useTranslation();
    const newMenu = useNewMenu();

    if (newMenu) {
        return (
            <SettingsLayout section="controlPolicies">
                <ControlPolicies />
            </SettingsLayout>
        );
    }

    return (
        <OrgApplicationBar title={t("ControlPolicies_Title")} routerLinks>
            <ControlPolicies />
        </OrgApplicationBar>
    );
}

function ControlPolicies() {
    // Non-admins get a 403, which the route's error boundary shows as "no access".
    const {
        data: { controlPolicies },
    } = useGetOrganizationSettingsSuspense({
        query: { select: (response) => response.data },
    });

    return (
        <SectionGroup>
            <ControlPolicyCard
                kind="loginProtection"
                policy={controlPolicies.loginProtection}
            />
            <ControlPolicyCard
                kind="segregationOfDuties"
                policy={controlPolicies.segregationOfDuties}
            />
            <ControlPolicyRecentChanges />
        </SectionGroup>
    );
}
